import { useAuth } from '@/shared/hooks/useAuth';

const DELETE_ROLES = new Set(['owner', 'admin', 'agency_admin']);

/**
 * Mirrors the backend's `authorize('admin', 'owner')` on the delete routes:
 * owners, admins and agency admins can delete verifications and imports;
 * managers and viewers only see the controls hidden.
 */
export function useCanDelete(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.isAgency || DELETE_ROLES.has(user.role ?? '');
}
